<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>{{ helpListTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
                v-bind:headers="headers"
                v-bind:items="items"
                v-bind:search="search"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                item-key="key"
                :loading="loading"
                :no-data-text="noDataText"
                v-model="selected"
                show-select
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class=" mr-2" @click="doSelect('All', 'insured')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class=" mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class=" mr-2" @click="doSelect('', 'insured')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import { expandURI } from '@/utils/ajax'
export default {
  props: {
    intr: String,
    refresh: Boolean,
    intrGrp: {
      type: String,
      default: ''
    },
    helpListTitle: {
      type: String,
      default: 'Intermediary HelpList'
    },
    listName: {
      type: String,
      default: 'intermediaries'
    }
  },
  data() {
    return {
      headers: [
        { text: 'Intermediary', value: 'intermediary' },
        { text: 'Description', value: 'intermediaryDesc' }
      ],
      selected: [],
      intermediaries: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  computed: {
    menu() {
      return this.$store.state.commons.menu
    }
  },
  watch: {
    refresh: function (value) {
      this.doInit()
    },
    menu: function () {
      this.doInit()
    }
  },
  methods: {
    async doInit() {
      if (this.intrGrp === 'All') {
        this.intrGrp = ''
      }
      this.intermediaries = this.intr.split(',')
      const apiURI = this.menu.commonDataList
      const expand = {
        listName: this.listName,
        paramString: this.intrGrp
      }
      if (apiURI) {
        this.loading = true
        await this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            this.items = []
            this.selectedItems = []
            if (result.data) {
              const data = result.data
              const dataList = data.dataList
              dataList.map((interList) => {
                const convertList = {
                  key: interList.value,
                  intermediary: interList.value,
                  intermediaryDesc: interList.label
                }
                if (this.checkedItems.includes(interList.value)) {
                  const intermediaryList = {
                    key: interList.value,
                    intermediary: interList.value,
                    intermediaryDesc: interList.label
                  }
                  this.selectedItems.push(intermediaryList)
                }
                this.items.push(convertList)
              })
            }
            if (this.checkedItems.toString() === 'All') {
              this.doReset()
              this.toggleAll()
            } else {
              this.toggleSelected()
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
          })
      }
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin]
}
</script>
